import { gql } from 'graphql-request';

export const DestroyAttachment = gql`
  mutation DestroyAttachment($attachment:DestroyAttachmentInput!) {
    destroyAttachment(input:$attachment) {
      id
      recordId
      recordType
      destroyed
    }
  }
`;
